module.exports = __webpack_public_path__ + "img/Message_white.d377fccd.svg";